import { useState, useEffect } from "react";
import Main from "./components/main/Main";
import { useSelector } from "react-redux";

import Login from "./pages/Login";

function Root() {
  const [tokenState, setTokenState] = useState("");

  const { MainResponse } = useSelector((state) => state);

  useEffect(() => {
    getToken();
  }, [MainResponse.adminLogged]);

  const getToken = () => {
    setTokenState(localStorage.getItem("token"));
  };

  return <div>{tokenState ? <Main /> : <Login />}</div>;
}

export default Root;
